import React, { memo } from "react"
import useSizeMap from "@hooks/useSizeMap"
import { Select } from "@chakra-ui/react"

export interface VariantSelectProps {
  selectedSku: string
  variants: any[]
  onSelectVariant: (sku: string) => void
}

const VariantSelect = ({ selectedSku, variants, onSelectVariant }: VariantSelectProps) => {
  const sizeMap = useSizeMap()

  return (
    <Select value={selectedSku} onChange={({ target: { value } }) => onSelectVariant(value)}>
      {variants.map(variant => {
        const size = variant.selectedOptions.find(({ name }: any) => name === "Size").value || ""

        return (
          <option key={size} value={variant.sku}>
            {sizeMap[size] || size}
          </option>
        )
      })}
    </Select>
  )
}

export default memo(VariantSelect)
